import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";

interface Props {
  person?:Person
  address?:Address
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonAddressComponent',
  props: {
    person: { default: undefined },
    address: { default: undefined }
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexColumn, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(SogIcon, { icon: "mdi-account" })
      ], 512), [
        [_vShow, props.person.personType==='Natural']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(SogIcon, { icon: "mdi-office-building" })
      ], 512), [
        [_vShow, props.person.personType==='Legal']
      ]),
      _createVNode(SogDataLabel, {
        value: props.person.personName
      }, null, 8, ["value"]),
      _createElementVNode("span", null, [
        _createVNode(SogDataLabel, {
          value: props.address?.street
        }, null, 8, ["value"]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createVNode(SogDataLabel, {
          value: props.address?.houseNumber
        }, null, 8, ["value"]),
        _createVNode(SogDataLabel, {
          value: props.address?.houseNumberAddition
        }, null, 8, ["value"])
      ]),
      _createElementVNode("span", null, [
        _createVNode(SogDataLabel, {
          value: props.address?.postalCode
        }, null, 8, ["value"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createVNode(SogDataLabel, {
          value: props.address?.city
        }, null, 8, ["value"])
      ]),
      _createVNode(SogDataLabel, {
        value: props.address?.countryName
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})